import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useRentalManagerUserPropertyRecommendationsWebApiHandler_recommendations } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import RecommendationsActions from '../../actions/Recommendations';

import TimeConstants from '../../constants/TimeConstants';
import ListingRecs from '../../model/ListingRecs';

/**
 * when using this query we need to sync data to the redux store.
 * call syncCurrentProperty on data change
 *
 *   useEffect(() => {
 *     if (listingRecommendationsData) {
 *       syncRecommendations({ data: listingRecommendationsData, isMultifamily, dispatch });
 *     }
 *   }, [listingRecommendationsData]);
 */
const useGetListingRecommendations = ({ listingAlias, fields = null, isMultifamily = false }, queryOptions = {}) => {
  // @ts-expect-error
  const { ZRM_USE_UPLIFT_BRAIN_TEST_DATA } = useSelector((state) => state.app.cookieEnabledServices);

  const result = useRentalManagerUserPropertyRecommendationsWebApiHandler_recommendations(
    {
      listingAlias,
      ...(fields && { manualListingRecommendationFields: fields }),
      useUpliftBrainTestData: ZRM_USE_UPLIFT_BRAIN_TEST_DATA,
    },
    {
      enabled: Boolean(listingAlias),
      staleTime: TimeConstants.SECONDS_10,
      ...queryOptions,
    },
  );

  const data = useMemo(() => (result.data ? ListingRecs(result.data) : undefined), [result.data]);

  return { ...result, data };
};

const syncRecommendations = ({ data, isMultifamily = false, dispatch }) => {
  const normalizedData = ListingRecs(data);

  dispatch(RecommendationsActions.updateRecommendations(normalizedData, isMultifamily));
};

export { syncRecommendations, useGetListingRecommendations };
